export default __webpack_public_path__ + "static/media/ic-admin.c4f9f19c.svg";